export default __webpack_public_path__ + "static/media/51881bc2891a0efa776bad09989acd6f.8d007e69.png";